import {useEffect, useState} from "react";
import {
    Step,
    StepDescription,
    StepIcon,
    StepIndicator,
    StepNumber,
    StepSeparator,
    StepStatus,
    StepTitle,
    Stepper,
    useSteps, Box,
} from '@chakra-ui/react'
import colors from '../../theme/colors';
import './stepper.scss'

const StrategyStepper = ({stepIndex, setSelectedStep}) => {
    const steps = [
        {title: 'Securities', description: 'Selezionate'},
        {title: 'First Bar', description: 'Iniziata ricerca First Bar'},
        {title: 'Second Bar', description: 'Iniziata ricerca Second Bar'},
        {title: 'Trade', description: 'Iniziata fase Trade'},
    ]

    const [clickedIndex, setClickedIndex] = useState(0);

    return (
        <Stepper index={stepIndex ?? 0} className="strategyStep">
            {steps.map((step, index) => (
                <Step key={index}>
                    <StepIndicator onClick={() => {
                        if (index < stepIndex) {
                            setSelectedStep(index);
                            setClickedIndex(index);
                        }
                    }}
                                   cursor={index < stepIndex ? 'pointer' : 'not-allowed'}
                                   opacity={index < stepIndex ? 1 : 0.5}
                                   sx={{
                                       bg: clickedIndex === index ? colors.greenLight : colors.greenDark,
                                       borderColor: clickedIndex === index ? colors.greenLight : colors.greenDark,
                                       '&:hover': {
                                           bg: clickedIndex === index ? colors.greenLight : colors.greenLight,
                                           borderColor: clickedIndex === index ? colors.greenLight : colors.greenLight,
                                       },
                                       // 🔐 Fissa lo stile anche dopo l'hover
                                       '&[data-status="complete"]': {
                                           bg: clickedIndex === index ? colors.greenLight : colors.greenDark,
                                           borderColor: clickedIndex === index ? colors.greenLight : colors.greenDark,
                                       }
                                   }}
                                   data-status="complete" // forza il reset post-hover
                    >
                        <StepStatus
                            complete={<StepIcon/>}
                            incomplete={<StepNumber/>}
                            active={<StepNumber/>}
                        />
                    </StepIndicator>

                    <Box flexShrink='0'>
                        <StepTitle>{step.title}</StepTitle>
                        <StepDescription>{step.description}</StepDescription>
                    </Box>

                    <StepSeparator/>
                </Step>
            ))}
        </Stepper>
    )
}
export default StrategyStepper;